export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-28">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>热门影视 · 每日更新</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              黑桃视频
              <span className="block text-2xl md:text-3xl lg:text-4xl font-sans font-light text-foreground-700 mt-1">
                你的高清影视娱乐天地
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-2">
              西瓜视频免费、西瓜视频高清全集在线观看，涵盖丝瓜视频等热门平台资源，
              不缓冲流畅播放体验。最新电视剧电影大全每日更新，
              热门综艺、动漫番剧一网打尽，随时随地畅享高清视听盛宴。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 md:gap-6 mb-8 mt-4">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-movie-2-line text-primary-500 text-lg"></i>
                <span>每日更新 <strong className="text-foreground-900">200+</strong> 部影片</span>
              </div>
              <div className="w-px h-5 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-accent-500 text-lg"></i>
                <span>覆盖 <strong className="text-foreground-900">热门影视</strong> 平台</span>
              </div>
              <div className="w-px h-5 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-speed-line text-primary-500 text-lg"></i>
                <span>高清 <strong className="text-foreground-900">不缓冲</strong> 畅快播放</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 hover:border-background-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-400/15 via-accent-400/10 to-primary-400/15 rounded-2xl blur-2xl"></div>
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20flowing%20film%20strips%20and%20soft%20golden%20light%20rays%2C%20modern%20entertainment%20atmosphere%2C%20elegant%20curved%20shapes%20in%20coral%20and%20warm%20amber%20tones%2C%20smooth%20gradient%20background%20with%20subtle%20texture%2C%20luxurious%20theater-inspired%20ambiance%2C%20no%20text%20or%20logos%2C%20editorial%20quality%2C%20high%20detail%2C%20harmonious%20warm%20color%20palette&width=1200&height=900&seq=hero-main-2026-x1&orientation=landscape"
                  alt="黑桃视频高清影视娱乐平台主视觉"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                  <div className="flex-1 bg-background-50/90 backdrop-blur-sm rounded-lg px-4 py-2.5 flex items-center gap-2">
                    <div className="w-8 h-8 rounded-md bg-primary-500 flex items-center justify-center shrink-0">
                      <i className="ri-play-fill text-background-50 text-sm"></i>
                    </div>
                    <div className="min-w-0">
                      <p className="text-xs text-foreground-900 font-medium truncate">热播剧场 · 最新剧集每日更新</p>
                      <p className="text-xs text-foreground-500">高清流畅 不缓冲播放</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}